import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  skipOnboardingMutation,
  skipOnboardingMutationVariables,
} from './__generated__/useSkipOnboardingMutation.graphql.ts';

const SKIP_ONBOARDING_MUTATION = gql`
  mutation skipOnboardingMutation($input: skipOnboardingInput!, $sport: Sport!) {
    skipOnboarding(input: $input) {
      currentUser {
        slug
        forcedIntoOnboarding(sport: $sport)
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<skipOnboardingMutation, skipOnboardingMutationVariables>;

export const useSkipOnboardingMutation = () => {
  return useMutation(SKIP_ONBOARDING_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
};
